import formModel from "./formModel";

const {
  formField: { phoneNumber, otpCode },
} = formModel;

export default {
  [phoneNumber.name]: "",
  [otpCode.name]: "",
};
